import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Offcanvas, Modal, Image, Alert } from 'react-bootstrap';
import countryService from '../services/countryService';
import { useNavigate } from 'react-router-dom';  // En üste ekleyin
import config from '../../config';

const ExhibitionsManagePage = () => {
  const navigate = useNavigate();  // useNavigate hook'unu ekleyin
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    coverImage: null
  });
  const [imagePreview, setImagePreview] = useState(null);

  // Add these handler functions
  const handleDrawerShow = () => setShowDrawer(true);
  const handleDrawerClose = () => {
    setShowDrawer(false);
    setFormData({ name: '', coverImage: null });
    setImagePreview(null);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        coverImage: file
      });
      
      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCountryClick = (countryId) => {
    // window.location.href yerine navigate kullan
    navigate(`/admin/exhibitions/country/${countryId}`);
  };

  const loadCountries = async () => {
    try {
      const data = await countryService.getCountries();
      console.log('Countries data:', data); // Gelen veriyi kontrol edelim
      setCountries(data);
      setError(null);
    } catch (error) {
      console.error('Failed to load countries:', error);
      setError('Failed to load countries');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCountries();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await countryService.addCountry(formData);
      handleDrawerClose();
      loadCountries(); // Reload countries after adding new one
    } catch (error) {
      // TODO: Add error handling (e.g., show toast message)
      console.error('Failed to add country:', error);
    }
  };
  // Add new state for delete modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [countryToDelete, setCountryToDelete] = useState(null);

  // Update existing handleDelete function
  const handleDelete = async (e, countryId) => {
    e.stopPropagation();
    setCountryToDelete(countryId);
    setShowDeleteModal(true);
  };

  // Add confirmDelete function
  const confirmDelete = async () => {
    try {
      await countryService.deleteCountry(countryToDelete);
      loadCountries();
      setShowDeleteModal(false);
    } catch (error) {
      console.error('Failed to delete country:', error);
    }
  };

  return (
    <Container fluid className="mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Exhibitions by Country</h2>
        <Button variant="primary" onClick={handleDrawerShow}>
          Add New Country
        </Button>
      </div>

      <Row xs={1} md={2} lg={3} className="g-4">
        {countries.map((country) => (
          <Col key={country.id}>
            <Card 
              className="h-100 shadow-sm hover-effect" 
              onClick={() => handleCountryClick(country.id)}
              style={{ cursor: 'pointer' }}
            >
              <Card.Img 
                variant="top" 
                src={country.cover_image ? `${config.API_URL.replace('/api', '')}${country.cover_image}` : '/default-country-image.jpg'}
                style={{ 
                  height: '200px', 
                  objectFit: 'cover' 
                }}
                onError={(e) => {
                  e.target.src = '/default-country-image.jpg';
                }}
              />
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <Card.Title>{country.name}</Card.Title>
                    <Card.Text>
                      Total Photos: {country.totalPhotos || 0}
                    </Card.Text>
                  </div>
                  <Button 
                    variant="danger" 
                    size="sm"
                    onClick={(e) => handleDelete(e, country.id)}
                  >
                    Delete
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Add Country Drawer */}
      <Offcanvas show={showDrawer} onHide={handleDrawerClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add New Country</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Country Name</Form.Label>
              <Form.Control 
                type="text" 
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter country name" 
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Cover Image</Form.Label>
              <Form.Control 
                type="file" 
                onChange={handleImageChange}
                accept="image/*"
                required
              />
            </Form.Group>

            {/* Image Preview */}
            {imagePreview && (
              <Form.Group className="mb-3">
                <Form.Label>Image Preview</Form.Label>
                <div className="text-center">
                  <Image 
                    src={imagePreview} 
                    alt="Preview" 
                    style={{ 
                      maxWidth: '100%', 
                      maxHeight: '200px', 
                      objectFit: 'cover',
                      border: '1px solid #ddd',
                      borderRadius: '4px'
                    }}
                    thumbnail
                  />
                </div>
              </Form.Group>
            )}

            <div className="d-grid gap-2">
              <Button variant="primary" type="submit">
                Save Country
              </Button>
            </div>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Add Delete Modal before closing Container */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Warning: Deleting this country will also delete all associated photos and exhibitions.</p>
          <p>Are you sure you want to proceed with deletion?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete Country
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ExhibitionsManagePage;
